import { Component, Inject, OnInit, ViewChild } from '@angular/core';
import { NgForm } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef, MatPaginator, MatSnackBar, MatSort, MatTableDataSource } from '@angular/material';
import { Airport } from '../models/airport.model';
import { AirportService } from '../airport.service';
import { BusinessManagerService } from '../../shared/user/business-manager.service';
import { AirportComment } from '../models/airport-comment.model';
import { RemarkService } from '../service/remark.service';


@Component({
  selector: 'app-admin-airport',
  templateUrl: './admin-airport.component.html',
  styleUrls: ['./admin-airport.component.scss']
})
export class AdminAirportComponent implements OnInit {
  airport: Airport;
  model: any = {};
  adminDeleteConfirmationArray: Array<boolean> = [];

  notesArray: Array<AirportComment>;
  dataSource: MatTableDataSource<any>;
  airportNotesToDelete: Array<any> = [];

  @ViewChild(MatSort) sort: MatSort;
  @ViewChild(MatPaginator) paginator: MatPaginator;

  constructor(public dialogRef: MatDialogRef<AdminAirportComponent>,
              @Inject(MAT_DIALOG_DATA) public data,
              private _airportService: AirportService,
              private _businessService: BusinessManagerService,
              public _snackBar: MatSnackBar,
              private _remarkService: RemarkService) {
    this.airport = data.airport;
    for (let i = 0; i < this.airport.admins.length; i++) {
      this.adminDeleteConfirmationArray.push(false);
    }
  }

  async ngOnInit() {
    if (!this.notesArray) {
      this.notesArray = await this._remarkService.getRemarks(this.airport.airportId);
    }
    this.setNotesDataSource();
  }

  async onAddNote(noteForm: NgForm) {
    try {
      const remark: AirportComment = {
        id: null,
        airportId: this.airport.airportId,
        sourceId: 3,
        commentType: AirportComment.parseCommentType('Admin'),
        commentRef: 'Notes',
        text: noteForm.value.note
      };
      const addedNote = await this._remarkService.postRemark(this.airport.airportId, remark);
      if (addedNote) {
        noteForm.controls['note'].setValue('');
        noteForm.form.markAsPristine();
        noteForm.form.markAsUntouched();
        this.notesArray = await this._remarkService.getRemarks(this.airport.airportId);
        this.setNotesDataSource();
      } else {
        this._snackBar.open('Add airport admin note failed: ' + addedNote, 'Close', {
          duration: 5000
        });
      }
    } catch (e) {
      const error = e as Error;
      this._snackBar.open('Add airport admin note failed: ' + error.message, 'Close', {
        duration: 5000
      });
    }
  }

  async onSaveNote(modifiedNote: any) {
    try {
      const remark: AirportComment = {
        id: modifiedNote.id,
        airportId: this.airport.airportId,
        sourceId: 3,
        commentType: AirportComment.parseCommentType('Admin'),
        commentRef: 'Notes',
        text: modifiedNote.text
      };
      const updatedNote = await this._remarkService.putRemark(this.airport.airportId, remark);
      if (updatedNote) {
        this.notesArray = await this._remarkService.getRemarks(this.airport.airportId);
        this.setNotesDataSource();
      } else {
        this._snackBar.open('Updating airport admin note failed: ' + updatedNote, 'Close', {
          duration: 5000
        });
      }
    } catch (e) {
      const error = e as Error;
      this._snackBar.open('Updating airpot admin note failed: ' + error.message, 'Close', {
        duration: 5000
      });
    }
  }

  async onDeleteNote(noteToDelete: any) {
    this.airportNotesToDelete.push(noteToDelete);
  }

  async deleteNote(confirmation: boolean, note: any) {
    if (confirmation) {
      const deletedNote = await this._remarkService.deleteRemark(this.airport.airportId, note.id);

      if (deletedNote) {
        this.notesArray = await this._remarkService.getRemarks(this.airport.airportId);
        this.setNotesDataSource();
      }
    }
    const index = this.airportNotesToDelete.indexOf(note, 0);
    this.airportNotesToDelete.splice(index, 1);
  }

  applyFilter(filterValue: string) {
    this.dataSource.filter = filterValue.trim().toLowerCase();
  }

  shouldDisplayDeleteButtons(notesForDeletion: any[], note: any): boolean {
    return notesForDeletion && notesForDeletion.length > 0 &&
      notesForDeletion.findIndex(n => n.id === note.id) !== -1;
  }

  onKeyUp() {
    this.model.recid = this.model.recid.replace(/\D/g, '');
  }

  setNotesDataSource() {
    this.dataSource = new MatTableDataSource(this.notesArray);
    this.dataSource.sort = this.sort;
    this.dataSource.paginator = this.paginator;
  }

  async onAddAdmin(addForm: NgForm) {
    const added = await this._businessService.addAirportManager(this.airport, this.model.recid);
    if (added && added === 'SUCCESS') {
      this.model.recid = '';
      addForm.form.markAsPristine();
      addForm.form.markAsUntouched();
      this.airport = await this._airportService.getAirport(this.airport.identifier, true);
    } else {
      this._snackBar.open('Add Admin Failed: ' + added, 'Close', {
        duration: 5000
      });
    }
  }

  onDeleteAdmin(index: number) {
    if (this.adminDeleteConfirmationArray[index]) {
      this.adminDeleteConfirmationArray[index] = false;
      return;
    }
    this.adminDeleteConfirmationArray[index] = true;
  }

  async onDeleteConfirm(recid: number, index: number) {
    const deleted = await this._businessService.deleteAirportManager(this.airport, recid);
    if (deleted && deleted === 'SUCCESS') {
      this.adminDeleteConfirmationArray[index] = false;
      this.airport = await this._airportService.getAirport(this.airport.identifier, true);
    } else {
      this._snackBar.open('Delete Admin Failed: ' + deleted, 'Close', {
        duration: 5000
      });
    }
  }
}
